import styled from "styled-components";

export const Container = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
  `}

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  padding: 4rem 3.2rem;
  width: 49.5rem;
`;

export const ContainerScroll = styled.div`
  .scroll {
    height: auto;
    overflow: auto;
    width: auto;
  }
  .scroll::-webkit-scrollbar {
    width: 3px;
  }

  .scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px #76bc21;
  }
`;

interface IContainerConfigurate {
  borderRadius?: string;
  maxHeight?: string;
  minHeight?: string;
  width?: string;
}
export const ContainerConfigurate = styled.div<IContainerConfigurate>`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    border-radius: ${props.borderRadius ? props.borderRadius : "0px"};
    max-height: ${props.maxHeight ? props.maxHeight : "auto"};
    min-height: ${props.minHeight ? props.minHeight : "auto"};
    width: ${props.width ? props.width : "49.5rem"};
    @media (max-width: 750px) {
      width: 48rem;
    }
  `}
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4rem 3.2rem;
`;
interface IButtonGeneric {
  backgroundColor?: string;
  border?: string;
  height?: string;
  marginTop?: string;
  marginBottom?: string;
}
export const ButtonGeneric = styled.button<IButtonGeneric>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    background-color: ${
      props.backgroundColor ? props.backgroundColor : props.theme.colors.white
    };
    border: ${
      props.border
        ? props.border
        : `1px solid ${props.theme.colors.primaryBlue}`
    };
    color: ${props.color ? props.color : props.theme.colors.primaryBlue};
    height: ${props.height ? props.height : "5rem"};
    margin-top:${props.marginTop ? props.marginTop : "0rem"};
    margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
  `}
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  justify-content: center;
  width: 100%;

  .icon {
    height: 5rem;
    width: 5rem;
  }
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
`;

interface IDivDetailTitle {
  fontWeight?: string | number;
  fontSize?: string;
}
export const DivDetailTitle = styled.div<IDivDetailTitle>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-weight:${props.fontWeight ? props.fontWeight : 800};
    font-size: ${props.fontSize ? props.fontSize : "1.4rem"};
    
  `}
  color: #2E353D;
`;

export const Subtitle = styled.h2`
  ${({ theme }) => `
    color: ${theme.colors.primaryBlue};
  `}
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 0;
`;

export const Title = styled.h1`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  font-size: 2.4rem;
  font-weight: 800;
  margin-bottom: 3.6rem;
  margin-top: 0.5rem;
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody + theme.transparencies.p30};
  `}
  font-size: 1.4rem;
  font-weight: 700;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HorizontalContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Text = styled.p`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};  
  `}
  font-size: 1.6rem;
  font-weight: 500;
`;

export const InfoContainer = styled.div`
  align-items: center;
  border-radius: 0.8rem;
  box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
  box-sizing: border-box;
  display: flex;
  height: 5rem;
  margin-bottom: 3rem;
  padding-left: 1.3rem;
  width: 43.1rem;

  & > p {
    ${({ theme }) => `
    color: ${theme.colors.blackTextBody};  
  `}
    font-size: 1.4rem;
    font-weight: 500;
    margin: 0;
  }
`;
